import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermFaqCategory from '@/components/TermFaqCategory';

const FaqPackingShippingPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">よくあるご質問</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <TermFaqCategory />
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="self-stretch px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">梱包・発送関連</div>
            </div>
            
            {/* FAQ Item 1 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">海外から発送してもいい？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center">
                  <span className="text-black text-base font-bold leading-7">海外からの商品の発送は、禁止行為</span>
                  <span className="text-black text-base font-normal leading-7">としております。<br/>必ず、日本国内にご登録いただいている住所から発送をお願いいたします。<br/>なお、出品商品の到着期限までにDONDON側で商品の到着を確認できない場合、取引がキャンセルとなる可能性があります。<br/>その際は、キャンセル料が発生し、商品は着払い（出品者様負担）で返送されますので、あらかじめご了承ください。</span>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">また、発送に関するルールや禁止事項などの詳細については、以下のページもあわせてご確認ください。</div>
                  <Link to={`/terms/guideline_packing_shipping${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">梱包・発送のガイドライン</Link>
                </div>
              </div>
            </div>

            {/* FAQ Item 2 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">複数の取引を同梱して発送していい？</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-start gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-bold leading-7">複数の取引をまとめて（同梱で）発送することが可能</span>
                  <span className="text-black text-base font-normal leading-7">です。<br/>同梱発送される際は、各商品に対応する取引IDを記載した付箋などを貼付のうえ、誤配送を防ぐように梱包をお願いいたします。<br/>なお、発送通知は取引ごとに個別で行っていただく必要があります。<br/>まとめて発送しても、すべての取引についてそれぞれ発送通知の操作を忘れずにお願いいたします。</span>
                </div>
              </div>
            </div>

            {/* FAQ Item 3 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">友人や家族など他アカウントの取引商品と一緒に発送してもいい？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center">
                  <span className="text-black text-base font-normal leading-7">DONDONでは、発送元の情報や伝票番号をもとに取引を特定しているため、</span>
                  <span className="text-black text-base font-bold leading-7">異なるアカウントの商品をひとつの梱包にまとめて発送することは禁止</span>
                  <span className="text-black text-base font-normal leading-7">しております。<br/>出品者様ごとに梱包を分け、それぞれ別々に発送していただくようお願いいたします。</span>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">梱包や発送に関する詳しいルール・注意事項については、以下のページをご確認ください。</div>
                  <Link to={`/terms/guideline_packing_shipping${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">梱包・発送のガイドライン</Link>
                </div>
              </div>
            </div>

            {/* FAQ Item 4 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">災害や交通状況によりDONDONへの到着期限を超過してしまいそう。</div>
              <div className="w-full pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">配送に遅延が発生している場合でも、到着期限を過ぎた際には、購入者様のご意向により取引がキャンセルとなる可能性がありますのでご注意ください。<br/>災害・交通規制・連休などの影響によって配送に遅れが生じている場合は、事務局までご連絡をお願いいたします。<br/>ご申告いただいた状況を踏まえたうえで、今後の対応についてあらためてご案内いたします。</div>
              </div>
            </div>

            {/* FAQ Item 5 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">商品発送時に日時指定は必要？</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-start gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-normal leading-7">DONDON宛に商品を発送する際は最短での到着処理を行うため、</span>
                  <span className="text-black text-base font-bold leading-7">配達日時は「指定なし」に設定</span>
                  <span className="text-black text-base font-normal leading-7">してください。<br/>DONDONに到着した荷物は順次開封・確認を行い、それぞれの取引と照合したうえで、該当取引画面から「到着通知」を行います。<br/>なお、DONDON上に表示される「到着日」は、運送会社の追跡情報上の配達完了日と一致しない場合がございますので、あらかじめご了承ください。<br/>また、DONDONへの到着状況にかかわらず、出品商品の到着期限を超過した場合には、取引がキャンセルとなる可能性がございます。<br/>キャンセルとなった際には、出品者様にキャンセル料が発生いたしますので、ご留意ください。<br/>※荷物の開封および取引との紐付けには、商品内容や量に応じてお時間をいただく場合があります。</span>
                </div>
              </div>
            </div>

            {/* FAQ Item 6 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">出品商品の到着期限はある？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">到着期限は、発送通知日を0日として+5日目の23:59です。<br/>【例】04/01 21:00に発送通知した場合の到着期限：04/06 23:59</div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">詳細は、以下のページをご確認ください。</div>
                  <Link to={`/terms/guideline_packing_shipping${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">梱包・発送のガイドライン</Link>
                </div>
              </div>
            </div>

            {/* FAQ Item 7 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">発送伝票にはなにを記載したらいい？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">発送先</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">住所：150-0011 東京都渋谷区東2-22-5 シブロジ 3F<br/>宛名：DONDON（取引ID） 宛<br/>※追跡可能な配送方法をご利用ください。</div>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">注意事項</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">・電話番号、日時指定は、未記入のままご発送ください<br/>・宛名欄には梱包商品の取引IDを必ずご記入ください<br/>・複数の商品を同梱する場合は、いずれか一つの取引IDを記載してください</div>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">発送元</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">氏名、住所、電話番号いずれも、DONDONに登録している情報を記入してください。</div>
                </div>
              </div>
            </div>

            {/* FAQ Item 8 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">お届け先・発送元住所を変更したい。</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">登録住所は、マイページから変更することができます。</div>
                <div className="self-stretch justify-center">
                  <span className="text-black text-base font-bold leading-7">対応手順（ウェブ版・モバイル版）<br/></span>
                  <span className="text-black text-base font-normal leading-7">1. 「マイページ」をタップ<br/>2. 「お届け先情報」をタップ<br/>3. 各項目を編集<br/>4. 「保存」をタップ</span>
                </div>
                <div className="flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">ただし、既に成立している取引には、変更内容（住所）は反映されません。取引中の場合は以下のリンクを参照の上、変更手続きをお願いいたします。</div>
                  <Link to={`/terms/faq_trade_purchase_sell${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">購入取引のお届け先を変更したい</Link>
                </div>
              </div>
            </div>

            {/* FAQ Item 9 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">発送した出品商品にトラブルが発生した。</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-start gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">出品商品の発送・持込方法やご利用の運送会社の選定は、すべて出品者様のご判断に基づいて行っていただいております。<br/>そのため、配送時に発生した輸送トラブル（破損・紛失・遅延等）については、事務局は直接の介入はできません。<br/>万が一、輸送中にトラブルが発生した場合は、出品者様ご自身にてご利用の運送会社とご協議のうえ、配送状況をご確認ください。<br/>その後、必要に応じて、事務局まで状況をご報告いただきますようお願いいたします。</div>
              </div>
            </div>

            {/* FAQ Item 10 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">運送会社により、誤った場所に配送されてしまった。</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center">
                  <span className="text-black text-base font-normal leading-7">お荷物が誤った場所に配送されている場合には、ご利用の運送会社へ直接お問い合わせのうえ、配送状況を事務局までご連絡ください。<br/>状況により取引の継続が困難と判断される場合には、事務局判断にて当該取引をキャンセルさせていただくことがあります。<br/>また、配送先住所の転送などが必要となった際には、以下の情報をご利用ください。<br/></span>
                  <span className="text-black text-base font-bold leading-7">住所：東京都渋谷区東2-22-5 シブロジ3F<br/>宛名：DONDON（取引ID）宛</span>
                </div>
              </div>
            </div>

            {/* FAQ Item 11 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">納品書やレシートは発送（同梱）が必要？</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-start gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-bold leading-7">納品書やレシートの発送は不要</span>
                  <span className="text-black text-base font-normal leading-7">です。<br/>同梱されていた場合でも、当社にて破棄いたします。<br/>返送のご対応は承っておりませんので、あらかじめご了承ください。<br/>同梱された書類に記載された個人情報については、適切な方法で破棄処理を行います。</span>
                </div>
              </div>
            </div>

            {/* FAQ Item 12 */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">どれくらいで商品が届く？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="self-stretch justify-center">
                  <span className="text-black text-base font-normal leading-7">取引成立から購入者様のもとに商品が届くまでには通常4〜12日程度の期間を要します。各工程の目安は以下の通りです。<br/></span>
                  <span className="text-black text-base font-bold leading-7">取引成立から出品者様による発送まで：1〜4日<br/>出品者様から当社への到着まで：1〜2日<br/>当社到着後の鑑定・検品および発送準備：1〜4日<br/>当社から購入者様への配送：1〜2日<br/></span>
                  <span className="text-black text-base font-normal leading-7">なお、上記日数はあくまで目安であり、出品者様・購入者様の居住地や配送状況、天候・交通事情等により前後する場合がございます。<br/>取引の進行状況に応じて柔軟にご対応いただき、余裕を持ってお待ちいただきますようお願いいたします。</span>
                </div>
                <div className="flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">注意事項</div>
                  <div className="w-[880px] justify-center text-black text-base font-normal leading-7">ご購入いただいた商品は、ヤマト運輸にて発送しております。<br/>当社倉庫にて直接商品の受け渡しはできませんのであらかじめご了承ください。</div>
                </div>
              </div>
            </div>
          </div>
          
          <TermFaqCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FaqPackingShippingPage;